/*
 * @Description: 用户参与及好感
 * @Author: yy
 * @Date: 2019-05-31 14:47:28
 * @LastEditors: yy
 * @LastEditTime: 2019-09-24 15:29:41
 */

import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './p26.css';

import ExportHeadTitle from '../../../components/ExportHeadTitle/ExportHeadTitle';
import ExportDes from '../../../components/ExportDes/ExportDes';
import ExportFootDes from '../../../components/ExportFootDes/ExportFootDes';
import ExportEcharts from '../../../components/ExportEcharts/ExportEcharts';

import {getUserParticipate} from '../../../controller';
import {favorComplatePolar} from '../../../chart';
import { getSessionQuery } from '../../../utils';

//  将数拆分 顺意，中立，逆意
const tidyData = (list) => {
  const better = []
  const neutrality = []
  const wrong = []

  list.forEach(item => {

    better.push({
      name: item.name,
      type: item.type,
      value: item.data[0] + item.data[1]
    });

    neutrality.push({
      name: item.name,
      type: item.type,
      value: item.data[2]
    });

    wrong.push({
      name: item.name,
      type: item.type,
      value: item.data[3] + item.data[4]
    });
  });
  return {
    better,
    neutrality,
    wrong
  };
};



class P26 extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      query: {
        brandName: '',
        startDate: '',
        statisDate: ''
      },
      summary: {
        sinfo: '',
        shunyiinfo: '',
        niyiinfo: ''
      },
      better: {},
      neutrality: {},
      wrong: {}
    };

    this.getData = this.getData.bind(this);
  }

  componentDidMount () {
    this.getData();
  }

  getQuery () {
    const query = getSessionQuery('query');

    const result = {
      brandNames: query.brand,
      startDate: query.beginTime,
      statisDate: query.endTime
    }
    if (query.isCustom === '1') {
      result.areaIndustry = query.industry
      result.competingBrands = query.competingGoods.map(item => item.value).join(',')
    }
    return result
  }

  getData () {
    const query = this.getQuery();

    getUserParticipate(Object.assign({report: true}, query))
      .then(data => {
        const chartList = tidyData(data.chartsJson);
        this.setState({
          query: query,
          summary: {
            sinfo: data.sinfo,
            shunyiinfo: data.shunyiinfo,
            niyiinfo: data.niyiinfo
          },
          better: favorComplatePolar(chartList.better, Object.assign(query, {
            title: '顺意群体',
            color: {
              kol: '#f7b1b2',
              general: '#f9d8d5'
            }
          })),
          neutrality: favorComplatePolar(chartList.neutrality, Object.assign(query, {
            title: '中立群体',
            color: {
              kol: '#ffd70d',
              general: '#ffec8e'
            }
          })),
          wrong: favorComplatePolar(chartList.wrong, Object.assign(query, {
            title: '逆意群体',
            color: {
              kol: '#4fb7ed',
              general: '#73cbfb'
            }
          }))
        })
      })
  }


  render() {
    const {query, summary} = this.state;
    return (
      <div className={s.container}>
        <ExportHeadTitle>用户参与及好感 – 重点竞品对比</ExportHeadTitle>

        <div>
          <ExportDes> {summary.sinfo} </ExportDes>

          <ExportDes> 
            <div>{summary.shunyiinfo}</div>
            <div>{summary.niyiinfo}</div>
          </ExportDes>
        </div>

        <div className={s.echartWrapper}>
          <div> <ExportEcharts option={this.state.better}></ExportEcharts> </div>
          <div> <ExportEcharts option={this.state.neutrality}></ExportEcharts> </div>
          <div> <ExportEcharts option={this.state.wrong}></ExportEcharts> </div>
        </div>

        <ExportFootDes
          brandName={query.brandNames}
          beginTime={query.startDate}
          endTime={query.statisDate}>
        </ExportFootDes>
      </div>
    );
  }
}

export default withStyles(s)(P26);



// WEBPACK FOOTER //
// src/routes/exportPDF/p26/p26.js